import React from "react";
import AvailablePlans from "../components/AvailablePlans";

const AvailableSubscriptions: React.FC = () => {
  return <AvailablePlans />;
};

export default AvailableSubscriptions;
